import { getDataInfoVideo, getDurada, removeHtmlTags } from '@portal-internet/core';
import clsx from 'clsx';
import CodiEspectador from 'components/3cat/CodiEspectador';
import Enllac from 'components/3cat/Enllac';
import { getUrl } from 'components/3cat/Enllac/Enllac';
import Imatge from 'components/3cat/Imatge';
import AfegeixALaLlista from 'components/3cat/ui/AfegeixALaLlista';
import Icona from 'components/3cat/ui/Icona';
import ProgressBar from 'components/3cat/ui/ProgressBar';
import { useProducte } from 'hooks/3cat/useProducte';
import __isEmpty from 'lodash/isEmpty';
import { useEffect, useState, useRef } from 'react';
import styles from './keyframe.module.scss';

const Keyframe = (props) => {
    const {
        data,
        className,
        priority,
        barraprogres,
        disponible,
        marcatgeAudienciesClick,
        mosaicPosition,
        mostrarNomPrograma,
        progres,
        showLogoPrograma,
        routeType,
        testId,
        tag
    } = props;

    const { titol, id, imatges, slug, nom_friendly, tipologia, domini, canals, entradeta, durada, nombonic, permatitle } = data;

    const imatgesPrograma = data.programes_tv?.[0]?.imatges;
    const { codi_etic, codi_alt, idRelacionat, tipologiaRelacionada } = getDataInfoVideo(data);
    const [isHover, setIsHover] = useState(false);
    const [divHover, setDivHover] = useState('');
    const [hoverHeight, setHoverHeight] = useState(null);
    const keyframeRef = useRef();

    const { isWebviewActive } = useProducte();
    const route = {
        type: routeType,
        id: id,
        slug: slug || nom_friendly || nombonic || permatitle,
        tipologia: tipologia,
        domini: domini,
        canals: canals
    };
    const nomPrograma = data.programes_tv?.[0]?.desc || data.programes_radio?.[0]?.desc;
    const audiencies = { tipologia: tipologia, url: getUrl({ route }), titol: titol, programa: nomPrograma, durada: durada };

    const _showLogoPrograma = () => {
        return (
            showLogoPrograma && (
                <div className={styles.logoprograma}>
                    <Imatge
                        imatges={imatgesPrograma}
                        tipus='web_logoprograma'
                        mostrarRecurs={false}
                        alt={titol}
                        width={173}
                        height={100}
                    />
                </div>
            )
        );
    };

    const stylesKeyframe = clsx({
        [styles.keyframe]: true,
        [styles.inactiu]: !disponible,
        [styles.mosaic]: !!mosaicPosition,
        [styles.isWebviewActive]: isWebviewActive,
        [className]: !__isEmpty(className)
    });

    useEffect(() => {
        let timeoutId;
        if (isHover) {
            setHoverHeight(keyframeRef.current?.offsetHeight || null);
            timeoutId = setTimeout(() => {
                setDivHover(styles.keyframeHover);
            }, 200);
        } else {
            timeoutId = setTimeout(() => {
                setDivHover('');
                setHoverHeight(null);
            }, 300);
        }

        return () => {
            clearTimeout(timeoutId);
        };
    }, [isHover]);

    const _getEntradeta = () => {
        const { entradeta_promo, entradeta } = data;
        return removeHtmlTags(entradeta_promo || entradeta);
    };

    const Tag = tag || `${'h2'}`;

    return data ? (
        <div
            key={`keyframe-${data.id}`}
            className={`${stylesKeyframe} ${divHover}`}
            style={hoverHeight ? { height: `${hoverHeight}px` } : undefined}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            data-testid='keyframe'
            ref={keyframeRef}
        >
            <div className={styles.wrapperItemMosaic}>
                <Enllac
                    route={isWebviewActive ? { ...route, format: 'PLAYER' } : route}
                    dataTestId={`enllac-keyframe-${testId}`}
                    marcatgeAudienciesClick={marcatgeAudienciesClick}
                >
                    <div className={styles.imatge}>
                        <Imatge
                            imatges={imatges}
                            tipus='web_mosaic'
                            alt={titol}
                            aria-hidden='true'
                            layout='fill'
                            objectFit='cover'
                            loading='lazy'
                            crop='555x312'
                            priority={false}
                        />
                        {_showLogoPrograma()}
                        <div className={styles.icona_play}>
                            {isWebviewActive && tipologia === 'WCR_AUDIO_MM' ? (
                                <Icona
                                    icona='auriculars_ple'
                                    className={`${styles.audio} ${styles.play}`}
                                    alt='reproduir'
                                    mida={28}
                                />
                            ) : (
                                <Icona icona='play' className={styles.play} alt='reproduir' mida={28} />
                            )}
                        </div>
                        {!isWebviewActive && tipologia === 'WCR_AUDIO_MM' && (
                            <div className={styles.iconaAudio}>
                                <Icona icona='auriculars_ple' alt='Àudio' mida={22} />
                            </div>
                        )}
                    </div>
                </Enllac>

                <Enllac
                    route={isWebviewActive ? { ...route, format: 'KEYFRAME' } : route}
                    className={styles.info}
                    marcatgeAudienciesClick={marcatgeAudienciesClick}
                >
                    <div className={`${styles.descripcio} ${isWebviewActive && styles.descripcioWebview}`}>
                        {mostrarNomPrograma && !__isEmpty(nomPrograma) && (
                            <span className={styles.nomPrograma}>{nomPrograma}</span>
                        )}
                        <Tag className={styles.titol} data-testid={`titol-keyframe-${testId}`}>
                            {titol}
                        </Tag>
                    </div>
                    <div className={`${styles.codiDurada} ${isWebviewActive && styles.isWebviewActive}`}>
                        {codi_etic && <CodiEspectador codi={codi_etic} alt={codi_alt} mida='25' className={styles.ico_codi} />}

                        {!__isEmpty(durada) && (
                            <>
                                <Icona
                                    className={styles.ico_clock}
                                    icona='rellotge'
                                    isBlanc={true}
                                    alt='Icona rellotge'
                                    mida='16'
                                    ariaHidden={true}
                                />
                                <div className={styles.durada}>
                                    <div>
                                        {' '}
                                        <span className='sr-only'>Durada: </span>
                                        {getDurada(String(durada))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {barraprogres && <ProgressBar className={`${styles.progres} ${mostrarNomPrograma}`} progress={progres} />}
                    <p className={styles.entradeta}>{_getEntradeta()}</p>
                </Enllac>
                {tipologia !== 'DTY_DESTACAT' && (
                    <AfegeixALaLlista
                        className={styles.afegeix}
                        tooltipPosition='left'
                        id={tipologia === 'DTY_DESTACAT' ? idRelacionat : id}
                        tipologia={tipologia === 'DTY_DESTACAT' ? tipologiaRelacionada : tipologia}
                        audiencies={audiencies}
                    />
                )}
            </div>
        </div>
    ) : (
        <></>
    );
};

Keyframe.defaultProps = {
    progres: '',
    disponible: true,
    barraprogres: true,
    className: '',
    mostrarNomPrograma: false
};

export default Keyframe;
